import * as angular from "angular";
import {TagModel} from "../angular/models/tag.model";

export class TagsDialogService {

  constructor(private $mdDialog) {
  }


  onCreateTag(tagType, showConfiguration?: boolean, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/create-edit-tag-dialog.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.header = 'Create Tag';
        $scope.action = 'Create';
        $scope.showConfiguration = showConfiguration;
        $scope.tag = {
          name: undefined,
          color: '#278BFF',
          type: tagType
        }

        if (showConfiguration) {
          $scope.tag.showOnApp = false;
          $scope.tag.showOnWorkforceApp = false;
          $scope.tag.hideOnConsole = false;
        }

        $scope.onColorChange = (color) => {
          $scope.tag.color = color;
        }

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////

        $scope.submit = () => {
          self.$mdDialog.hide($scope.tag);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  onEditTag(tag: TagModel, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/create-edit-tag-dialog.html').default,
      parent: angular.element(document.body),
      controller: function ($scope) {

        $scope.header = 'Edit Tag';
        $scope.action = 'Edit';

        $scope.showConfiguration = tag.type === 'Info';
        $scope.tag = tag;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onColorChange = (color) => {
          $scope.tag.color = color;
        }

        /////////////////////////

        $scope.submit = () => {
          self.$mdDialog.hide($scope.tag);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.tags')
  .service('tagsDialogService', TagsDialogService);
